import { render, staticRenderFns } from "./StaffCascader.vue?vue&type=template&id=b3ad7e90&scoped=true&"
import script from "./StaffCascader.vue?vue&type=script&lang=js&"
export * from "./StaffCascader.vue?vue&type=script&lang=js&"
import style0 from "./StaffCascader.vue?vue&type=style&index=0&id=b3ad7e90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ad7e90",
  null
  
)

export default component.exports